import React, { useState } from 'react';
import { Box, Grid, Typography, TextField, Button, Link } from '@mui/material';
import 'dayjs/locale/ko'; 
import BaseCodeSelectbox from '../../common/form/selectbox/BaseCodeSelectbox';
import EmpModalContainer from '../../../containers/common/form/modal/EmpModalContainer';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; 
import DateAdapter from '@mui/lab/AdapterDateFns';
import * as dayjs from 'dayjs'


const ProjectDetailForm = ({ formik, project }) => {
  const [openEmp, setOpenEmp] = useState(false);
  const [title, setTitle] = useState('사원찾기');

  const openEmpModal = (type, title) => {
    setTitle(title);
    setOpenEmp(true);
  };
  const handleEmpClose = () => {
    setOpenEmp(false);
  };

  const selectedEmployee = (emp) => {
    formik.setFieldValue(`crtNm`, emp.usrNm, true);
    formik.setFieldValue(`crtUsr`, emp.usrUuid, false);
  };

  return (
    <div>
      <Box
        component="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
        noValidate
        autoComplete="off"
        onSubmit={formik.handleSubmit}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            py: 2,
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <Button
            type="submit"
            variant="outlined"
            disabled={formik.isSubmitting}
          >
            저장
          </Button>
        </Box>

        <Box sx={{ mt: 1 }}>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
            sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
          >
            <Grid item xs={1}>
              <Typography variant="subtitle2" component="div">
                프로젝트 타입
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <BaseCodeSelectbox
                formik={formik}
                filterObject={{
                  blcCd: 'BASE',
                  mlcCd: 'FORCAST',
                  slcCd: 'PRJ_TYP',
                  useYn: 'Y',
                }}
                name="prjTyp"
                size="small"
                required={true}
              />
            </Grid>
            <Grid item xs={1}>
              <Typography variant="subtitle2" component="div">
                거래처 유형
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <BaseCodeSelectbox
                formik={formik}
                filterObject={{
                  blcCd: 'BASE',
                  mlcCd: 'PARTNER',
                  slcCd: 'PARTNER_TYP',
                  useYn: 'Y',
                }}
                name="partnerTyp"
                size="small"
                required={true}
              />
            </Grid>
            <Grid item xs={1}>
              <Typography variant="subtitle2" component="div">
                매출 예상일
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
                <DatePicker
                  format="YYYY-MM-DD"
                  mask={'____-__-__'}
                  id="expDay"
                  name="expDay"
                  value={dayjs(formik?.values?.expDay)}
                  onChange={(newValue) => {
                    // setExpDay(newValue);
                    // onChangeDate(newValue, 'expDay');
                    formik.setFieldValue('expDay', dayjs(newValue));
                  }}
                  slotProps={{
                    textField: {
                      variant: "outlined",
                      size: "small",
                      required: true,
                      fullWidth: true,
                      error: formik.touched.expDay && Boolean(formik.errors.expDay),
                      helperText: formik.touched.expDay && formik.errors.expDay,
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
          
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
            sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
          >
            <Grid item xs={1}>
              <Typography variant="subtitle2" component="div">
                매출처
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="body2" component="div">
                {project?.vendorCmpNm}
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="subtitle2" component="div">
                영업 담당자
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <TextField
                size="small"
                required={true}
                variant="outlined"
                disabled
                fullWidth
                id="crtNm"
                name="crtNm"
                value={formik.values.crtNm}
                onChange={formik.handleChange}
                error={formik.touched.crtNm && Boolean(formik.errors.crtNm)}
                helperText={formik.touched.crtNm && formik.errors.crtNm}
              />
            </Grid>
            <Grid item={1}>
              <Button
                variant="outlined"
                size="small"
                onClick={() => openEmpModal('', '영업담당자 선택')}
              >
                영업담당자 선택
              </Button>
            </Grid>
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
            sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
          >
            <Grid item xs={1}>
              <Typography variant="subtitle2" component="div">
                고객사
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="body2" component="div">
                {project?.customerNm}
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="subtitle2" component="div">
                고객사 담당자
              </Typography>
            </Grid>
            <Grid item xs={6}>
            <Typography variant="body2" component="div">
                담당자명 : {project?.chargeNm} / 메일주소 : {project?.chargeEml} / 연락처 :  {project?.chargeTel}
              </Typography> 
            </Grid>
            
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
            sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
          >
            <Grid item xs={1}>
              <Typography variant="subtitle2" component="div">
                사업명
              </Typography>
            </Grid>
            <Grid item xs={11}>
              <Typography variant="body2" component="div">
                {project?.cstNm}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
            sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
          >
            <Grid item xs={1}>
              <Typography variant="subtitle2" component="div">
                예산 여부
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="body2" component="div">
                {project?.bugetYn}
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="subtitle2" component="div">
                프로젝트 중요도
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="body2" component="div">
                {project?.prjImpt}
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="subtitle2" component="div">
                조달 여부
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="body2" component="div">
                {project?.procurement}
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="subtitle2" component="div">
                제품 여부
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="body2" component="div">
                {project?.productYn}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
            sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
          >
            <Grid item xs={1}>
              <Typography variant="subtitle2" component="div">
                참고사항
              </Typography>
            </Grid>
            <Grid item xs={11}>
              <TextField
                size="small"
                variant="outlined"
                fullWidth
                id="forcastTxt"
                name="forcastTxt"
                multiline
                rows={5}
                value={formik.values.forcastTxt}
                onChange={formik.handleChange}
                error={
                  formik.touched.forcastTxt && Boolean(formik.errors.forcastTxt)
                }
                helperText={
                  formik.touched.forcastTxt && formik.errors.forcastTxt
                }
              />
            </Grid>
          </Grid>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            py: 2,
            borderTop: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <Button
            type="submit"
            variant="outlined"
            disabled={formik.isSubmitting}
          >
            저장
          </Button>
        </Box>
      </Box>
      {openEmp && (
        <EmpModalContainer
          title={title}
          multi={false}
          open={openEmp}
          roleTyp="SALES"
          handleClose={handleEmpClose}
          selectedEmployee={selectedEmployee}
        />
      )}
    </div>
  );
};

export default ProjectDetailForm;
